export enum SchemaMarkupType {
    BreadcrumbList = 'BreadcrumbList',
    ListItem = 'ListItem',
    Place = 'Place',
    PostalAddress = 'PostalAddress',
    SportsEvent = 'SportsEvent',
    Thing = 'Thing',
}
